import { useEffect, useMemo, useState } from "react";
import { newAxiosClient } from "@shadowcue/ui";
import type { IScriptTemplate } from "@shadowcue/ui";

interface UseScriptTemplateResult {
  template: IScriptTemplate | null;
  loading: boolean;
  error: boolean;
}

const useScriptTemplateForConversation = (
  scriptTemplateId: number | null,
  authToken: string,
): UseScriptTemplateResult => {
  const axios = useMemo(() => newAxiosClient(), []);

  const [template, setTemplate] = useState<IScriptTemplate | null>(null);
  const [loading, setLoading] = useState<boolean>(scriptTemplateId !== null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (scriptTemplateId === null) {
      setLoading(false);
      return;
    }

    const headers = { AUTHORIZATION: `Bearer ${authToken}` };

    axios
      .get<{ scriptTemplate: IScriptTemplate }>(
        `/api/script_templates/${scriptTemplateId}`,
        { headers },
      )
      .then((res) => setTemplate(res.data.scriptTemplate))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [scriptTemplateId]);

  return { template, loading, error };
};

export default useScriptTemplateForConversation;
